interface Props {
  status: 'online' | 'offline' | 'degraded' | 'active' | 'locked' | 'disabled';
}

const styles: Record<string, string> = {
  online: 'bg-emerald-100 text-emerald-700',
  active: 'bg-emerald-100 text-emerald-700',
  offline: 'bg-red-100 text-red-700',
  disabled: 'bg-red-100 text-red-700',
  degraded: 'bg-amber-100 text-amber-700',
  locked: 'bg-amber-100 text-amber-700',
};

const labels: Record<string, string> = {
  online: 'Online',
  active: 'Aktiv',
  offline: 'Offline',
  disabled: 'Deaktiviert',
  degraded: 'Eingeschr.',
  locked: 'Gesperrt',
};

export function StatusBadge({ status }: Props) {
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${styles[status] ?? 'bg-slate-100 text-slate-600'}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${
        status === 'online' || status === 'active' ? 'bg-emerald-500' :
        status === 'offline' || status === 'disabled' ? 'bg-red-500' :
        'bg-amber-500'
      }`} />
      {labels[status] ?? status}
    </span>
  );
}
